import { ReadingChoices } from '@/components/ReadingChoices';
import { OpenReading } from '@/components/ReadingChoices/open';
import { Question } from './';

type BodyProps = {
  questions: Question[];
  questionIndex: number;
};

export const Body = ({ questions, questionIndex }: BodyProps) => {
  const { choices, questionText, questionType, openQuestionAnswer } =
    questions?.[questionIndex] ?? {};
  const isOpen = questionType == 'open';

  return !isOpen ? (
    <ReadingChoices questionText={questionText} choices={choices} />
  ) : (
    <OpenReading
      questionIndex={questionIndex}
      questionText={questionText}
      openQuestionAnswer={openQuestionAnswer}
    />
  );
};
